module.exports = __webpack_public_path__ + "static/media/Gilderoy Lockhart 2.7f5ad0ac.jpg";